import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-teal-700/30 bg-zinc-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-42" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-43" data-mp="xt91xg2m6s13">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-44" data-mp="xsfqw2wmhgd5">
          Stop Guessing. <span className="text-orange-400" data-id="element-45" data-mp="17qvjybf7mzpa">Start Understanding Your Boiler Room.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-46" data-mp="1lia44lkut6xx">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-teal-400 bg-zinc-950 px-4 py-3 text-sm font-semibold text-white" data-id="element-47" data-mp="1hiswblhyfxpl" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-teal-400 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-48" data-mp="27da0fwvo3fic" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}